<script>
    export let question;
    export let answer;
    export let search;

    let shown;

    $: {
        shown = false;
        if (!search)
            shown = true;
        else {
            shown = question.toUpperCase().indexOf(search.toUpperCase()) != -1 ||
                    answer.toUpperCase().indexOf(search.toUpperCase()) != -1;
        }
    }

    let expanded = false;

    const clickHandler = () => expanded = !expanded;
    const paragraphs = answer.split(">>");
</script>

<style>
	.container {
        width: 100%;
        padding: 15px;
        border-top: solid 1px #ffffff33;
	}

    .container h1 {
        font-weight: 200;
        font-size: 26px;
        cursor: pointer;
        margin: 0;
    }

    .container p {
        font-weight: 300;
        font-size: 18px;
        line-height: 140%;
        margin: 0;
        margin-top: 10px;
        margin-bottom: 10px;
        max-width: 600px;
    }
</style>

{#if shown}
    <div class="container">
        <h1 on:click={clickHandler}>{question}</h1>
        {#if expanded}
            {#each paragraphs as paragraph}
                <p>{paragraph}</p>
            {/each}
        {/if}
    </div>
{/if}
